/* src/app/components/app-attachment-browser/attachment-browser.component.scss */
a {
  color: #000000;
  cursor: pointer;
}
a:hover {
  color: #6c757d;
  cursor: pointer;
}
ul,
li {
  text-align: left;
}
ul.directories {
  padding-left: 10px;
  padding-right: 10px;
}
ul.directories li {
  list-style: none;
}
ul.directories li:before {
  content: "";
}
ul.directories li.open:before {
  content: "";
}
ul.directories li.file:before {
  content: "";
}
.thumbnail {
  min-width: 200px;
  min-height: 200px;
  max-width: 200px;
  max-height: 200px;
}
.thumbnail-content {
  min-height: 100px;
  max-height: 100px;
}
.vertical-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.set-font {
  font-family:
    Roboto,
    "Helvetica Neue",
    sans-serif;
}
/*!
 * The tree view (right side)
 */
/*# sourceMappingURL=attachment-browser.component-3QOICYMH.css.map */
